/* eslint-disable no-param-reassign */
import {
  DRL_COMPOUNDING_ALIAS,
  DRL_COMPOUNDING_PERIODS_ALIAS,
  DRL_DIVIDEND_RATE_ALIAS,
} from 'common/constants/cap-table';
import { FieldAttribute } from 'common/types/store';
import { alphabetGenerator } from 'utilities';
import { DividendRateReverserParser } from './types';

const sanitizeValue = (
  rawValue: string | number | null | undefined,
  alias: string,
  fieldAttributes: FieldAttribute
) => {
  let value: any = rawValue;
  switch (alias) {
    case DRL_COMPOUNDING_ALIAS:
      value = Boolean(value);
      break;
    case DRL_DIVIDEND_RATE_ALIAS:
      value = Number(value).toFixed(
        fieldAttributes[DRL_DIVIDEND_RATE_ALIAS as keyof FieldAttribute].decimal_places as number
      );
      break;
    case DRL_COMPOUNDING_PERIODS_ALIAS:
      value = ['', undefined, null].includes(value) ? null : Number(value);
      break;
    default:
      break;
  }
  return value;
};

const reverseParser: DividendRateReverserParser = params => {
  const { cells, tableData, rowConfig, fieldAttributes } = params;
  const { cellColumnRef, columns, securities } = tableData;
  // find column with columnRef equal to cellColumnRef
  const securityToUpdate = securities.find(item => item.columnRef === cellColumnRef);

  if (!securityToUpdate) {
    return [];
  }
  const alphabet = alphabetGenerator([], columns.length);
  columns.forEach((column, index) => {
    const colLetter = alphabet[index];
    rowConfig.forEach((row, rowIndex) => {
      const key = `${colLetter}${rowIndex + 1}`;
      const cell = cells[key];
      const { value: rawValue, alias } = cell;
      (column as any)[row.alias] = sanitizeValue(rawValue as any, alias, fieldAttributes);
    });
  });
  securityToUpdate.dividend_rate_ledger_items = columns;
  return columns;
};

export default reverseParser;
